module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_cuadrada_marco_comida_31.d67557cd.png";